import React from 'react';
import { useState } from 'react';
import '../css/Footer.css';
import emailjs from '@emailjs/browser';
import { AiFillGithub, AiFillLinkedin } from 'react-icons/ai';

function Footer() {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [message, setMessage] = useState('')

  function sendEmail(e){
    e.preventDefault();

    if(name === '' || email === '' || message === ''){
      alert('Preencha todos os campos')
      return;
    }

    const templateParans = {
      from_name: name,
      message: message,
      email: email
    }

    emailjs.send('service_wreqoev', 'template_j5bogwn', templateParans, 'jTwAMLJy8fR86zxH_')
    .then((reponse)=>{
      console.log("Email enviado", reponse.status, reponse.text)
      setName('')
      setEmail('')
      setMessage('')
    }, (error)=>{
      console.log("ERRO: ", error)
    })
  }



  return (
    <div className="container">
      
      <h1 className="title">Contato</h1>


      <form className="form" onSubmit={sendEmail}>
        <input 
          className="input"
          type="text"
          placeholder="Digite seu nome"
          onChange={(e) => setName(e.target.value)}
          value={name}
        />
        
        <input 
          className="input"
          type="text"
          placeholder="Digite seu email"
          onChange={(e) => setEmail(e.target.value)}
          value={email}
        />

        <textarea 
          className="textarea"
          placeholder="Digite sua mensagem..."
          onChange={(e) => setMessage(e.target.value)}
          value={message}
        />

        <input className="button" type="submit" value="Enviar" />
      </form>

      <div className='redes'>
        <a href="https://github.com/douglasarthurr" target="_blank" rel="noopener noreferrer"><AiFillGithub size={30}></AiFillGithub></a>
        <a href="https://www.linkedin.com/in/douglas-arthur-da-silva-bento-81903b261/" target="_blank" rel="noopener noreferrer"><AiFillLinkedin size={30}></AiFillLinkedin></a>
      </div>

    </div>
  );
}

export default Footer;
